module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.form_ErrorMessage) ? [_c('h3', {
    class: {
      'form-title': _vm.qrCode
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.formData.title)))]), _vm._v(" "), (_vm.action === 'select') ? _c('div', {
    staticClass: "w5-block-bordered cp"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('operation/bonus_information')),
      expression: "localeFtc('operation/bonus_information')"
    }],
    staticClass: "w5-block-bordered-text"
  })]) : _vm._e(), _vm._v(" "), _c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\r\n\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.localErrorMessage)) + "\r\n\t\t\t\t"), _c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")])])]), _vm._v(" "), (_vm.form_GetData['status'] === 'form') ? [(_vm.form_GetData['template']) ? _c('div', {
    staticStyle: {
      "margin": "20px 0"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.form_GetData['template'])
    }
  }) : _vm._e(), _vm._v(" "), _c('form', {
    ref: "mainFormForPay",
    staticClass: "w5-from outer-form",
    attrs: {
      "action": _vm.form_GetData['action'] ? _vm.form_GetData['action'] : null,
      "method": _vm.form_GetData['method'] ? _vm.form_GetData['method'] : null
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.form_Loading
    }
  }, [_vm._l((_vm.formData.fields), function(row, index) {
    return (row) ? _c('div', {
      key: index,
      class: {
        'w5-form-row': _vm.isVisibleField(row),
          'divider-field': _vm.isDividerField(row)
      }
    }, _vm._l((row), function(field) {
      return _c('Field', {
        key: field._field_name,
        attrs: {
          "isVisibleRow": _vm.isVisibleField(row),
          "objID": _vm.id,
          "crud": _vm.crud,
          "action": _vm.action,
          "Field": field,
          "listBlockToOut": true,
          "bigButton": field._field_name === 'fake_2_1',
          "bigButtonTitle": field._field_name === 'fake_2_1' ? 'operation/pay' : null,
          "bigButtonHandler": field._field_name === 'fake_2_1' ? _vm.onEnterKeyDown : null,
          "bigButtonEnabled": field._field_name === 'fake_2_1' && _vm.isSubmitButtonEnabled,
          "linkButton": field._field_name === 'fake_2_2',
          "linkButtonTitle": field._field_name === 'fake_2_2' ? 'paymentauto/update_title' : null,
          "linkButtonUrl": '/paymentauto/create',
          "linkButtonVisible": _vm.showAutoPaymentButton
        },
        on: {
          "valueChanged": function($event) {
            return _vm.fieldChanged(field)
          },
          "blur": function($event) {
            return _vm.onBlur(field)
          },
          "focus": function($event) {
            return _vm.onFocus(field)
          },
          "enterKeyDown": _vm.onEnterKeyDown,
          "operationNextStep": _vm.onClientCreateOperation,
          "deleteSavedPayment": _vm.onDeleteSavedPayment
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      })
    }), 1) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "w5-field"
  }, [(_vm.action === 'pay') ? _c('button', {
    ref: "submit_button",
    staticClass: "btn btn-submit btn-primary w5-button-save",
    class: {
      hidden: _vm.form_Loading
    },
    attrs: {
      "type": "button",
      "disabled": _vm.buttonBlock > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("\r\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('operation/pay')) + "\r\n\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), (_vm.action === 'pay' && !_vm.isPayLocked) ? _c('div', {
    staticClass: "select-pay1"
  }, [_c('span', {
    staticClass: "w5-link linkified",
    class: {
      hidden: _vm.form_Loading
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goToSelect($event)
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "arrow-left"
    }
  }), _vm._v("\r\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('operation/select_title')) + "\r\n\t\t\t\t\t")], 1)]) : _vm._e()], 2)]), _vm._v(" "), (!_vm.isExternalForm && _vm.isHashField) ? _c('div', {
    staticClass: "payment-link-wrapper"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")('operation/payment_link_description')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "2px 0"
    }
  }, [_c('a', {
    ref: "paymentLinkUrl",
    staticClass: "payment-link",
    attrs: {
      "href": _vm.paymentLinkUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.paymentLinkUrl))]), _vm._v(" "), _c('font-awesome-icon', {
    attrs: {
      "icon": "copy",
      "title": _vm._f("ftc")('main/copy_to_clipboard')
    },
    on: {
      "click": _vm.copyPaymentLink
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPayerDialogModal),
      expression: "showPayerDialogModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hidePayerDialogModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('payer/payer')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hidePayerDialogModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "alert alert-warning margin-0"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('payer/new_alert')),
      expression: "localeFtc('payer/new_alert')"
    }],
    staticClass: "padding-0-5"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit",
    on: {
      "click": _vm.goToCreatePayer
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('payer/create_title')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDeleteModal),
      expression: "showDeleteModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/deleting')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.deleteModalText),
      expression: "deleteModalText"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.deleteModalTimer && _vm.deleteModalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.deleteModalCallback
    }
  }, [_vm._v(_vm._s(_vm.deleteButtonTitle))])])])])])])] : (_vm.form_GetData['status'] === 'ok') ? [_c('div', {
    staticStyle: {
      "padding": "5px 0",
      "border-bottom": "1px solid #eee"
    }
  }), _vm._v(" "), (_vm.qrCode) ? _c('div', {
    staticClass: "w5-form-row"
  }, [(_vm.qrCode) ? _c('img', {
    staticClass: "qr-image",
    class: {
      'ext': !_vm.$store.state.is_auth
    },
    attrs: {
      "src": _vm.qrCode
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.formData.fields), function(row, index) {
    return (row) ? _c('div', {
      key: index,
      class: {
        'w5-form-row': _vm.isVisibleField(row)
      }
    }, _vm._l((row), function(field) {
      return (field.type !== 'hidden' && field.type !== 'fake' && field.type !== 'image') ? _c('div', {
        key: field._field_name,
        staticStyle: {
          "padding": "5px 0",
          "border-bottom": "1px solid #eee",
          "width": "100%"
        }
      }, [(field.type !== 'fake') ? _c('span', {
        staticStyle: {
          "width": "100px",
          "font-weight": "500"
        }
      }, [_vm._v(_vm._s(_vm._f("ftc")(field.title)) + ":")]) : _vm._e(), _vm._v(" "), _c('br'), (field._field_name !== 'summ') ? _c('span', {
        directives: [{
          name: "withSafeTags",
          rawName: "v-withSafeTags",
          value: (_vm.localeFtc(field.value)),
          expression: "localeFtc(field.value)"
        }]
      }) : _c('span', [_vm._v(_vm._s(_vm._f("money")(parseFloat(field.value).toFixed(2))) + " "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
        }
      })])]) : _vm._e()
    }), 0) : _vm._e()
  }), _vm._v(" "), (_vm.form_GetData && _vm.form_GetData.html) ? _c('span', {
    staticClass: "w5-modal-link order-link",
    on: {
      "click": function($event) {
        return _vm.openDocumentModalDialog(_vm.form_GetData.html, _vm.form_GetData.pdf)
      }
    }
  }, [_c('div', {
    staticClass: "attach-no-image-preview"
  }, [_vm._v("HTML")]), _vm._v(_vm._s(_vm.localeFtc('main/open') + ' ' + _vm.localeFtc('document/document').toLowerCase()) + "\r\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.form_GetData && _vm.form_GetData.pdf) ? _c('a', {
    staticClass: "order-link",
    attrs: {
      "href": _vm.form_GetData.pdf,
      "download": "download"
    }
  }, [_c('div', {
    staticClass: "attach-no-image-preview"
  }, [_vm._v("PDF")]), _vm._v(_vm._s(_vm._f("ftc")('operation/bill_pdf')) + "\r\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.form_GetData && _vm.form_GetData.link) ? _c('a', {
    staticClass: "order-link fas",
    attrs: {
      "href": _vm.form_GetData.link,
      "download": "download"
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "comment-dollar"
    }
  }), _vm._v(" " + _vm._s(_vm._f("ftc")('operation/pay')) + "\r\n\t\t\t")], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDocumentModalDialog),
      expression: "showDocumentModalDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideDocumentModalDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container for-document",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('document/document')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideDocumentModalDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.isPrintReady) ? _c('span', {
    staticClass: "btn btn-submit pull-left",
    on: {
      "click": _vm.documentPrint
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/print')))]) : _vm._e(), _vm._v(" "), (_vm.documentModalDialogLink) ? _c('a', {
    staticClass: "btn btn-submit pull-right",
    attrs: {
      "href": _vm.documentModalDialogLink,
      "download": "download"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/download')))]) : _vm._e()])])])]), _vm._v(" "), (_vm.action === 'pay') ? _c('div', {
    staticClass: "select-pay2",
    class: {
      'back-without-links': !_vm.form_GetData || (!_vm.form_GetData.html && !_vm.form_GetData.pdf)
    }
  }, [_c('span', {
    staticClass: "w5-link linkified",
    class: {
      hidden: _vm.form_Loading
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goToSelect($event)
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "arrow-left"
    }
  }), _vm._v("\r\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('operation/select_title')) + "\r\n\t\t\t\t")], 1)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.isExternalForm && _vm.isHashField) ? _c('div', {
    staticClass: "payment-link-wrapper"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")('operation/payment_link_description')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "2px 0"
    }
  }, [_c('a', {
    ref: "paymentLinkUrl",
    staticClass: "payment-link",
    attrs: {
      "href": _vm.paymentLinkUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.paymentLinkUrl))]), _vm._v(" "), _c('font-awesome-icon', {
    attrs: {
      "icon": "copy",
      "title": _vm._f("ftc")('main/copy_to_clipboard')
    },
    on: {
      "click": _vm.copyPaymentLink
    }
  })], 1)]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showGeneralDialog),
      expression: "showGeneralDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideGeneralDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.generalDialogTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideGeneralDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.generalDialogText),
      expression: "generalDialogText"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    class: {
      'btn-submit-danger': _vm.generalDialogButtonStyle === 1
    },
    attrs: {
      "disabled": _vm.generalDialogTimer && _vm.generalDialogTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.generalDialogCallback
    }
  }, [_vm._v(_vm._s(_vm.generalDialogButtonTitle))])])])])])])] : _c('errorAlert', {
    attrs: {
      "message": _vm.form_ErrorMessage
    }
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "document-wrapper"
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "frameborder": "0",
      "id": "documentFrame",
      "name": "documentFrame",
      "seamless": ""
    }
  }, [_vm._v("\r\n\t\t\t\t\t\t\t\t\tВаш браузер не поддерживает показ документа\r\n\t\t\t\t\t\t\t\t")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9eeb3756"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/crud/ClientPay.vue
// module id = 693
// module chunks = 0